import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding: 0 7%;
  background-color: #fff;
`;

export const TopBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 20px 0 8px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: #555;
  padding: 4px 8px 4px 0;
  line-height: 1;

  &:hover { color: #111; }
`;

export const LogoWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0 28px;

  img {
    width: 120px;
    height: auto;
  }
`;

export const TitleWrap = styled.div`
  width: 100%;
  margin-bottom: 28px;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.03em;
  margin-bottom: 6px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #888;
  line-height: 1.5;
`;

export const SearchWrap = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 16px;
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 50px;
  padding: 0 16px 0 46px;
  border: none;
  border-radius: 14px;
  background-color: #f5f5f5;
  font-size: 15px;
  color: #111;
  box-sizing: border-box;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.15s;

  &::placeholder { color: #bbb; }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #1fbc7040;
    background-color: #fff;
  }
`;

export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  flex: 1;
  padding-bottom: 32px;
`;

export const UniversityCard = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  background-color: #f9f9f9;
  border: 1.5px solid #efefef;
  border-radius: 14px;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s, transform 0.1s;

  &:hover {
    background-color: #f0fdf7;
    border-color: #a8ecd0;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const UniversityIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: #e8f9f1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
`;

export const UniversityName = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #111;
  flex: 1;
`;

export const ArrowIcon = styled.span`
  font-size: 14px;
  color: #bbb;
  flex-shrink: 0;
`;

export const EmptyText = styled.p`
  text-align: center;
  color: #bbb;
  font-size: 14px;
  padding: 40px 0;
`;

export const LoadingText = styled.p`
  text-align: center;
  color: #bbb;
  font-size: 14px;
  padding: 40px 0;
`;
